/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-param-reassign */
import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios'
import { ADMIN_URLS } from 'constans/urls'

import queryString from 'query-string'
import { getWithExpiry } from 'utils/localStorage'

const onRequest = (config: InternalAxiosRequestConfig) => {
  const userName = getWithExpiry('userName')
  config.headers.userName = userName
  config.headers.secretkey = process.env.REACT_APP_SECRET_KEY
  config.headers.Api_Key = process.env.REACT_APP_API_KEY
  config.paramsSerializer = params =>
    queryString.stringify(params, { arrayFormat: 'index' })
  return config
}

const onRequestError = (error: AxiosError) => {
  return Promise.resolve(error)
}

const onResponse = (response: AxiosResponse) => {
  const data = response.data
  if (data?.ErrorCode === 2) {
    sessionStorage.removeItem('userName')
    sessionStorage.removeItem('password')
    if (window.location.pathname !== ADMIN_URLS.LOGIN) {
      window.location.href = ADMIN_URLS.LOGIN
      return
    }
    return
  }
  return data
}

const onResponseError = (responseError: AxiosError) => {
  return Promise.reject(responseError)
}

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
})

axiosInstance.interceptors.request.use(onRequest, onRequestError)
axiosInstance.interceptors.response.use(onResponse, onResponseError)

export default axiosInstance
